import React from 'react';
import { BrowserRouter as Router, Routes, Route, useLocation } from 'react-router-dom';
import VideoBackground from './components/VideoBackground';
import Home from './components/Home';
import FormPage from './components/FormPage';
import Showcase from './components/Showcase';
import './App.css';

function AppRoutes() {
  const location = useLocation();
  const hideVideoBackground = location.pathname === '/showcase';
  const whatsappUrl = 'https://wa.me/916375275670';

  return (
    <>
      {!hideVideoBackground && <VideoBackground />}
      <Routes>
        <Route path="/" element={<Home />} />
        <Route path="/form" element={<FormPage />} />
        <Route path="/showcase" element={<Showcase />} />
      </Routes>
      <a
        href={whatsappUrl}
        className="whatsapp-float"
        target="_blank"
        rel="noopener noreferrer"
        aria-label="Chat on WhatsApp"
      >
        <svg viewBox="0 0 24 24" aria-hidden="true">
          <path
            fill="currentColor"
            d="M20.52 3.48A11.86 11.86 0 0 0 12.06 0C5.53 0 .21 5.31.21 11.85c0 2.09.55 4.14 1.58 5.96L0 24l6.35-1.66a11.79 11.79 0 0 0 5.71 1.46h.01c6.53 0 11.85-5.32 11.85-11.85 0-3.16-1.23-6.13-3.4-8.47Zm-8.46 18.3h-.01a9.88 9.88 0 0 1-5.03-1.37l-.36-.21-3.77.99 1.01-3.68-.23-.38a9.9 9.9 0 0 1-1.52-5.28c0-5.48 4.46-9.93 9.94-9.93 2.65 0 5.14 1.03 7.01 2.91a9.84 9.84 0 0 1 2.91 7.02c0 5.48-4.46 9.93-9.95 9.93Zm5.44-7.44c-.3-.15-1.78-.88-2.05-.98-.27-.1-.47-.15-.67.15-.2.3-.77.98-.95 1.18-.17.2-.35.22-.65.07-.3-.15-1.27-.47-2.42-1.5-.9-.8-1.5-1.8-1.67-2.1-.17-.3-.02-.46.13-.6.14-.14.3-.35.45-.52.15-.17.2-.3.3-.5.1-.2.05-.37-.03-.52-.08-.15-.67-1.63-.92-2.23-.24-.58-.49-.5-.67-.5h-.57c-.2 0-.52.07-.8.37-.27.3-1.03 1-1.03 2.43 0 1.42 1.05 2.8 1.2 2.99.15.2 2.06 3.15 5 4.42.7.3 1.24.47 1.66.6.7.22 1.34.19 1.84.12.56-.08 1.78-.73 2.03-1.43.25-.7.25-1.3.17-1.43-.07-.12-.27-.2-.57-.35Z"
          />
        </svg>
      </a>
    </>
  );
}

function App() {
  return (
    <Router>
      <AppRoutes />
    </Router>
  );
}

export default App;
